import { render, staticRenderFns } from "./AppStorePage.vue?vue&type=template&id=e413f14c&scoped=true"
import script from "./AppStorePage.vue?vue&type=script&lang=js"
export * from "./AppStorePage.vue?vue&type=script&lang=js"
import style0 from "./AppStorePage.vue?vue&type=style&index=0&id=e413f14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e413f14c",
  null
  
)

export default component.exports